import type * as Types from 'app/types/graphql';

import { VariantTemplateSelectFragmentDoc } from '../fragments/variantTemplate.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantTemplateUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateVariantTemplateInput;
}>;

export type VariantTemplateUpdateMutationResponse = {
  variantTemplateUpdate?: Types.Maybe<
    Pick<
      Types.VariantTemplate,
      | 'createdAt'
      | 'deletedAt'
      | 'id'
      | 'redirectURL'
      | 'themeID'
      | 'updatedAt'
      | 'thumbnailURL'
      | 'title'
    >
  >;
};

export const VariantTemplateUpdateDocument = `
    mutation VariantTemplateUpdate($id: ID!, $input: UpdateVariantTemplateInput!) {
  variantTemplateUpdate(id: $id, input: $input) {
    ...VariantTemplateSelect
  }
}
    ${VariantTemplateSelectFragmentDoc}`;

export const useVariantTemplateUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantTemplateUpdateMutationResponse,
    TError,
    VariantTemplateUpdateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantTemplateUpdateMutationResponse,
    TError,
    VariantTemplateUpdateMutationVariables,
    TContext
  >(
    ['VariantTemplateUpdate'],
    (variables?: VariantTemplateUpdateMutationVariables) =>
      appFetcher<VariantTemplateUpdateMutationResponse, VariantTemplateUpdateMutationVariables>(
        VariantTemplateUpdateDocument,
        variables,
      )(),
    options,
  );
};

useVariantTemplateUpdateMutation.getKey = () => ['VariantTemplateUpdate'];
